<template>
  <div v-if="showDisclaimer" class="my-6">
    <InformationBox :type="InformationBoxTypes.WARNING">
      <template #infoBoxContent>
        <div v-html="bindings.postContent"></div>
        <RACQFormKit v-model="model" :bindings="bindings" class="py-2" />
      </template>
    </InformationBox>
  </div>
</template>

<script setup lang="ts">
import { VueFormInputProps } from '@/composables/useFormInputData';
import { onMounted, ref, watch } from 'vue';
import RACQFormKit from '@/components/RACQFormKit/RACQFormKit.vue';
import { InformationBoxTypes } from '@/interfaces/forms/information-box.interface';
import InformationBox from '@/components/InformationBox/InformationBox.vue';

const props = defineProps<{
  iqStore: any;
  bindings: VueFormInputProps;
  stepActive?: boolean;
}>();

const model = ref<boolean>(false);
const showDisclaimer = ref<boolean>(false);

onMounted(async () => {
  showDisclaimer.value = await props.iqStore.checkUpdatePostalAddressRequired();
});

watch(
  () => props.stepActive,
  async (newValue: boolean) => {
    if (!newValue) return;
    showDisclaimer.value = await props.iqStore.checkUpdatePostalAddressRequired();
  }
);
</script>
